import { Tracker } from './tracker';
import { Driver } from './driver';
import { NotificationType } from './notification-type';
import { Delivery } from './delivery';

export class NotificationAlert {
    id: number;
    tracker:Tracker;
    driver:Driver;
    delivery:Delivery;
    type:NotificationType;
    dt_active:Date;
    dt_inactive:Date;
    isActive:boolean;
    data:number;

    constructor (id:number, tracker:Tracker, driver:Driver, delivery:Delivery,
                     type:NotificationType, dt_active:Date, dt_inactive:Date, isActive:boolean, data:number) {
        this.id = id;
        this.tracker = tracker;
        this.driver = driver;
        this.type = type;        
        this.dt_active = dt_active;
        this.dt_inactive = dt_inactive;
        this.isActive = isActive;
        this.data = data;
        this.delivery = delivery;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/notification-alert.ts